import { WarehouseAttributes } from '@/types'
import { UpdateWarehouseMutation } from './__generated__/update_mutation'
import { Mutation as UpdateMutation } from './update_mutation'
import { useForm } from '@/helpers/useForm'
import { EditWarehouseQuery } from './__generated__/edit_query'
import { Query as EditQuery } from './edit_query'
import { Inline as Loading } from '@/components/loading'
import { Inline as Error } from '@/components/error'

type Warehouse = EditWarehouseQuery['warehouses']['nodes'][0]

interface Props {
  id: string
  onSuccess: () => void
}

export const Form = ({ id }: Props) => {
  const {
    save,
    saveSuccess,
    formBuilder,
    queryError,
    queryLoading,
    mutationLoading,
  } = useForm<UpdateWarehouseMutation, WarehouseAttributes, EditWarehouseQuery, Warehouse>({
    id,
    initializer: warehouse => ({
      name: warehouse.name,
      address1: warehouse.address1,
      address2: warehouse.address2,
      address3: warehouse.address3,
      city: warehouse.city,
      county: warehouse.county,
      postcode: warehouse.postcode,
    }),
    query: EditQuery,
    queryKey: 'warehouses',
    mutation: UpdateMutation,
    resultKey: 'updateWarehouse'
  })

  if (queryLoading) return <Loading />

  return (
    <>
      { queryError && <Error message={queryError} /> }
      <div className="flex flex-col gap-6">
        { formBuilder.buildQueryError() }
        { formBuilder.buildField({ name: 'Name', field: 'name', type: 'text' }) }
        <div className="grid grid-cols-3 gap-6">
          { formBuilder.buildField({ name: 'Address Line 1', field: 'address1', type: 'text' }) }
          { formBuilder.buildField({ name: 'Address Line 2', field: 'address2', type: 'text' }) }
          { formBuilder.buildField({ name: 'Address Line 3', field: 'address3', type: 'text' }) }
          { formBuilder.buildField({ name: 'City', field: 'city', type: 'text' }) }
          { formBuilder.buildField({ name: 'County', field: 'county', type: 'text' }) }
          { formBuilder.buildField({ name: 'Postcode', field: 'postcode', type: 'text' }) }
        </div>
        { formBuilder.saveButton(save, mutationLoading, saveSuccess) }
      </div>
    </>
  )
}
